import React, { useState } from 'react';

function ContactForm() {
  const [formData, setFormData] = useState({
    parentName: '',
    studentName: '',
    contactInfo: ''
  });
  
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Formspree endpoint - set as environment variable REACT_APP_FORMSPREE_ENDPOINT
    // e.g. https://formspree.io/f/yourFormId
    const endpoint = process.env.REACT_APP_FORMSPREE_ENDPOINT || 'https://formspree.io/f/yourFormId';

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          parentName: formData.parentName,
          studentName: formData.studentName,
          contactInfo: formData.contactInfo
        })
      });

      const data = await res.json();

      if (res.ok) {
        setSubmitted(true);
        setFormData({ parentName: '', studentName: '', contactInfo: '' });
        setTimeout(() => setSubmitted(false), 5000);
      } else {
        // Formspree returns errors in `errors` array
        const message = (data && data.error) || (data && data.errors && data.errors.map(e => e.message).join(', ')) || 'Submission failed';
        setError(message);
      }
    } catch (err) {
      setError('Network error - please try again later.');
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <h2>Ready to Get Started?</h2>
        <p className="contact-subtitle">Fill out the form below and we'll reach out to discuss your student's needs</p>
        
        {submitted && (
          <div className="success-message">
            ✓ Thank you! We'll be in touch soon.
          </div>
        )}

        {error && (
          <div className="error-message" role="alert">
            ⚠ {error}
          </div>
        )}
        
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="parentName">Parent/Guardian Name *</label>
            <input
              type="text"
              id="parentName"
              name="parentName"
              value={formData.parentName}
              onChange={handleChange}
              required
              placeholder="Your full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="studentName">Student Name *</label>
            <input
              type="text"
              id="studentName"
              name="studentName"
              value={formData.studentName}
              onChange={handleChange}
              required
              placeholder="Student's full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="contactInfo">Contact Information (Email or Phone) *</label>
            <input
              type="text"
              id="contactInfo"
              name="contactInfo"
              value={formData.contactInfo}
              onChange={handleChange}
              required
              placeholder="your.email@example.com or (555) 123-4567"
            />
          </div>

          <button type="submit" className="submit-button">Send Inquiry</button>
        </form>
      </div>
    </section>
  );
}

export default ContactForm;
